// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"2629da93","529":"7247dcdf"}[chunkId] + ".chunk.js";
};